(function () {
  class GambleIntro extends PIXI.Container {
    constructor() {
      super();

      this._numFS = undefined;
      this._callbackOnBaseHidden = undefined;
      this._callback = undefined;
      this._screenDim = undefined;
      this._splashContinue = undefined;

      this._totemParent = undefined;
      this._popup = undefined;
      this._introText1 = undefined;
      this._freespinIntroElements = [];
      this.visible = false;
      this._screenDimTargetAlpha = 0.6;

      this._startFreeSpinsButton = undefined;
      this._gambleButton = undefined;

      this.youHaveFreeSpinsText = undefined;
      this._x3WinChance = undefined;
      this._x4WinChance = undefined;

      this._freeSpinsIntroOutro = undefined;

      this._fsBack = undefined;

      this._fsText1 = undefined;
      this._fsText2 = undefined;
      this._fsText3 = undefined;

      this._possibleValues = undefined;

      this._winIntroAnim = undefined;
      this._winAnimIntroPositions = [];

      this._currentFSIndex = 0;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.gambleBorder = resourceManager.get(
        "gambleIntroContainer:GambleIntro:gambleBorder"
      );

      this._welcomeToText = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsWelcomeText"
      );
      this.youHaveFreeSpinsText = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsYouHaveText"
      );

      this._startFreeSpinsButton = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsButton"
      );
      this._gambleButton = resourceManager.get(
        "gambleIntroContainer:GambleIntro:gambleButton"
      );

      this._gambleDisclaimer = resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer"
      );
      this._gambleSpin = resourceManager.get("gambleSpinContainer:GambleSpin");

      this._startFreeSpinsButton.mousedown =
        this._startFreeSpinsButton.touchstart = this.onClickedStart.bind(this);
      this._gambleButton.mousedown = this._gambleButton.touchstart =
        this.onClickedGamble.bind(this);

      this._freeSpinsIntroOutro = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
      );

      this._fsBack = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsBack"
      );

      this._fsText1 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsNumber1"
      );
      this._fsText2 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsNumber2"
      );
      this._fsText3 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsNumber3"
      );
      this._freeSpinsSplit1 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsSplit1"
      );
      this._freeSpinsSplit2 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsSplit2"
      );
      this._freeSpinsSplit3 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsSplit3"
      );
      this._burstAnim = resourceManager.get(
        "gambleIntroContainer:GambleIntro:burstAnim"
      );

      this._winIntroAnim = resourceManager.get(
        "gambleIntroContainer:GambleIntro:winGlow"
      );
      this._winIntroAnim.visible = false;
      this._winIntroAnimTween = null;

      this.orientationChange();

      messageBus.subscribe("Gamble:Risk", this.onCommittedToGamble.bind(this));
      messageBus.subscribe("Gamble:Collect", this.onClickedStart.bind(this));
      messageBus.subscribe(
        "Gamble:OfferGamble",
        this.onGambleOffered.bind(this)
      );

      Reflex.registerEventHandler(
        "orientationChange",
        this.orientationChange.bind(this)
      );
    }

    orientationChange() {
      this._winAnimIntroPositions = [];
      this._winAnimIntroPositions.push(this._fsText1.position.get());
      this._winAnimIntroPositions.push(this._fsText2.position.get());
      this._winAnimIntroPositions.push(this._fsText3.position.get());

      this._winIntroAnim.position.set(
        this._winAnimIntroPositions[this._currentFSIndex].x,
        this._winAnimIntroPositions[this._currentFSIndex].y
      );
    }

    onClickedStart() {
      this._startFreeSpinsButton.interactive = false;
      this._gambleButton.interactive = false;
      this._callback("collect");
      this.visible = false;

      if (this._winIntroAnimTween) {
        this._winIntroAnimTween.kill();
        this._winIntroAnimTween = null;
      }
      this._winIntroAnim.visible = false;
    }

    doFS() {
      const self = this;
      timerManager.addTimer(
        10,
        function (progress) {
          self.alpha = 1 - progress;
        },
        function () {
          resourceManager.getContainer("freeSpinsContainer").visible = true;

          self.alpha = 1;
          self.visible = false;

          self._winIntroAnim.visible = false;
          if (self._winIntroAnimTween) {
            self._winIntroAnimTween.kill();
            self._winIntroAnimTween = null;
          }

          self._callback();
        }
      );
    }

    onCommittedToGamble() {
      this._callback("gambled");
    }

    reactivate(numFS, x3WinChance, x4WinChance, callback) {
      this._x3WinChance = x3WinChance;
      this._x4WinChance = x4WinChance;
      this._callback = callback;

      this._gambleSpin.start(
        this._x3WinChance,
        this._x4WinChance,
        this._possibleValues,
        false
      );
    }

    onGambleOffered() {
      let showDisclaimerButton = resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer:showAgainToggle"
      );
      let inRecovery = gameController.getIsRecovery();
      let show = showDisclaimerButton.getShowDisclaimer();

      const self = this;
      if (show && !inRecovery) {
        this._winIntroAnim.position.set(
          this._winAnimIntroPositions[this._currentFSIndex].x,
          this._winAnimIntroPositions[this._currentFSIndex].y
        );
        this._gambleDisclaimer.start(
          this._x3WinChance,
          this._x4WinChance,
          this._possibleValues
        );
      } else {
        this._gambleSpin.start(
          this._x3WinChance,
          this._x4WinChance,
          this._possibleValues,
          true
        );
      }
    }

    onClickedGamble() {
      messageBus.postImmediate("Gamble:OfferGamble");
      soundManager.play("buttonPressV1");
      if (this._winIntroAnimTween) {
        this._winIntroAnimTween.kill();
        this._winIntroAnimTween = null;
      }
      this._winIntroAnim.visible = false;
    }

    doShowIntro(numFS, callback) {
      this._numFS = numFS;
      this._callback = callback;
      this._freeSpinsIntroOutro.showIntro(this._numFS, this.doFS.bind(this));
    }

    start(
      numFS,
      x3WinChance,
      x4WinChance,
      possibleValues,
      fsIndex,
      hiddenCallback,
      callback
    ) {
      this._numFS = numFS;
      this._x3WinChance = x3WinChance;
      this._x4WinChance = x4WinChance;

      this._callbackOnBaseHidden = hiddenCallback;
      this._callback = callback;

      this.visible = true;
      this._possibleValues = possibleValues;

      this._fsText1.text = this._possibleValues[0];
      this._fsText2.text = this._possibleValues[1];
      this._fsText3.text = this._possibleValues[2];

      resourceManager.getContainer("gambleIntroContainer").visible = true;

      this.gambleBorder.visible = false;
      this._welcomeToText.visible = false;
      this.youHaveFreeSpinsText.visible = false;
      this._fsBack.visible = false;
      this._fsText1.visible = false;
      this._fsText2.visible = false;
      this._fsText3.visible = false;
      this._freeSpinsSplit1.visible = false;
      this._freeSpinsSplit2.visible = false;
      this._freeSpinsSplit3.visible = false;
      this._burstAnim.visible = false;
      this._startFreeSpinsButton.visible = false;
      this._gambleButton.visible = false;

      fsIndex = Object.values(GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS).indexOf(
        numFS
      );
      // if (numFS === 7) {
      //   fsIndex = 0;
      // } else if (numFS === 10) {
      //   fsIndex = 1;
      // }

      this._winIntroAnim.position.set(
        this._winAnimIntroPositions[fsIndex].x,
        this._winAnimIntroPositions[fsIndex].y
      );
      this._currentFSIndex = fsIndex;
      this._winIntroAnimTween = gsap.fromTo(
        this._winIntroAnim,
        3,
        {
          rotation: 0,
        },
        {
          rotation: 360,
          rotation: Math.PI * 2,
          repeat: -1,
          ease: "none",
        }
      );

      messageBus.post("Gamble:IntroVisible");
      var recoveryController = resourceManager.getController(
        "GameRecoveryController"
      );

      let inRecovery = gameController.getIsRecovery();
      if (inRecovery) {
        recoveryController.onIntroVisible();
        this.onGambleOffered();
      }

      this._callbackOnBaseHidden();

      this.showIntro();
      musicManager.onGambleStart();
    }

    showIntro() {
      this.bounceIn(this.gambleBorder, 0.5);
      this.bounceIn(this._welcomeToText, 1);
      this.bounceInFreeSpinsText(this.youHaveFreeSpinsText, 1, this._numFS);
      this.bounceIn(this._fsBack, 1);
      this.bounceIn(this._fsText1, 1);
      this.bounceIn(this._fsText2, 1);
      this.bounceIn(this._fsText3, 1);
      this.bounceIn(this._freeSpinsSplit1, 1);
      this.bounceIn(this._freeSpinsSplit2, 1);
      this.bounceIn(this._freeSpinsSplit3, 1);
      // this.bounceIn(this._burstAnim, 1);
      this.bounceIn(this._startFreeSpinsButton, 1.2);
      this.bounceIn(this._gambleButton, 1.2);

      gsap.fromTo(
        this._winIntroAnim.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: 1.4,
          duration: 1,
          ease: "power1.out",
          x: this._winIntroAnim.scale.x,
          y: this._winIntroAnim.scale.y,
          onStart: () => {
            this._winIntroAnim.visible = true;
            this._winIntroAnim.alpha = 1;
          },
        }
      );
    }

    setActive() {
      this._startFreeSpinsButton.interactive = true;
      this._gambleButton.interactive = true;
    }

    bounceIn(object, delay) {
      const scaleTo = object.scale.x;

      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: 1,
          ease: "Bounce.easeOut",
          x: scaleTo,
          y: scaleTo,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
        }
      );
    }

    bounceInFreeSpinsText(object, delay, numFS) {
      const scaleTo = object.scale.x;

      let self = this;
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: 1,
          ease: "Bounce.easeOut",
          x: scaleTo,
          y: scaleTo,
          onStart: () => {
            self.youHaveFreeSpinsText.setTranslationParameters(numFS);
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }
  }

  let gambleIntroCreator = function (json) {
    return new GambleIntro();
  };

  let gambleIntroInitialiser = function (json, fsIntro) {
    fsIntro.initialise();
  };

  let gambleIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "GambleIntro",
    gambleIntroCreator,
    gambleIntroInitialiser,
    gambleIntroFilesRequired
  );
})();
